<template>
  <a href="demo-centers" class="btn-wrapper">
    <div class="img-wrapper">
      <img src="@/assets/icon-try.svg" alt="Try icon">
    </div>
    <div class="text">Test Drive Contrology<br><span>Find an Authorized Demo Center</span></div>
  </a>
</template>

<script>
  export default {
    name: 'ctabutton'
  }
</script>

<style lang="scss" scoped>
.btn-wrapper {
  width: 100%;
  height: 85px;
  max-width: 340px;
  border: 1px solid #878787;
  border-radius: 3px;
  background-color: var(--white);
  margin: 35px 0;
}

.img-wrapper {
  display: flex;
  background-color: #c9d7a1;
  width: 100%;
  height: 100%;
  max-height: 85px;
  max-width: 85px;
  justify-content: center;
  align-items: center;
}

img {
  width: 53px;
  height: 53px;
}

a {
  display: flex;
  font-family: var(--noto);
  font-size: 1rem;
  line-height: 1.111;
  text-decoration: none;
  color: var(--black);
  cursor: pointer;
}

a span {
  font-family: var(--roboto);
  font-size: 0.775rem;
  line-height: 1.214;
  color: #5f6062;
}

a .text {
  align-self: center;
  justify-self: center;
  margin: 3px 10px 3px 15px;
}

@media only screen and (min-width:400px) {
  a {
    font-size: 1.125rem;
    line-height: 1.111;
  }

  a span {
    font-size: 0.875rem;
    line-height: 1.214;
  }
}
</style>